@if (configuracion.titulo || configuracion.botonCerrar || configuracion.url) {
  <mat-toolbar
    class="encabezado fondo-primario-contraste"
    [class.superpuesto]="configuracion.encabezadoSuperpuesto"
  >
    <span class="titulo">
      {{ configuracion.titulo ?? '' }}
    </span>
    <div class="botones">
      @if (configuracion.url !== undefined) {
        <button
          mat-icon-button
          [matTooltip]="'Abrir en nueva ventana'"
          tabindex="-1"
          (click)="abrirUrl()"
        >
          <mat-icon>open_in_new</mat-icon>
        </button>
      }
      @if (configuracion.botonCerrar) {
        <button mat-icon-button tabindex="-1" (click)="dialogRef.close(null)">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  </mat-toolbar>
}

<ng-template #contenedor></ng-template>
